<template>
  <div class="inp_container">
    <BaseTooltip :tooltip="tooltip" :tooltipDisabled="tooltipDisabled">
      <div
        class="base-input"
        :class="{ 'base-input--view': view }"
        :style="{ maxWidth: typeof maxWidth === 'string' ? maxWidth : maxWidth + 'px' }"
      >
        <div class="base-input__header">
          <label
            v-if="label"
            :class="[
              labelSize ? 'f' + labelSize : 'f14',
              bold ? 'bold' : '',
              classLabel ? classLabel : '',
            ]"
          >
            {{ label }}
          </label>
          <span v-if="labelSecond && !view" class="f14 label_second">{{ labelSecond }}</span>
        </div>
        <div class="base-input__body">
          <transition name="fade" mode="out-in">
            <!-- <v-skeleton-loader
          v-if="!create && !workDocsWorkAreaShow"
          width="100%"
          height="86px"
          type="list-item"
      /> -->
            <v-hover v-slot="{ hover }" ref="hover">
              <BaseLink
                v-if="link"
                :text="viewValue || value"
                :type="linkType"
                :link="typeof link === 'string' ? link : null"
              />
              <div class="rel" v-else-if="!view">
                <v-text-field
                  :class="classInput"
                  ref="text"
                  v-if="type === 'text'"
                  v-bind:value="value"
                  @input="$emit('input', $event)"
                  outlined
                  :width="width"
                  :height="height"
                  :placeholder="placeholder || label"
                  :prepend-inner-icon="prependInnerIcon"
                  :disabled="disabled"
                  :readonly="readonly"
                  :rules="rulesCheck"
                  :hide-details="hideDetails !== undefined ? hideDetails : 'auto'"
                  @blur="edit = true"
                  :append-outer-icon="appendOuterIcon"
                  :type="inputType"
                  :name="inputName"
                  @change="handleChange"
                  :autocomplete="autocomplete"
                  :counter="counter"
                  :error-messages="errorMessage"
                  :autofocus="autofocus"
                >
                  <template v-slot:append-outer>
                    <slot name="append-outer">
                      <div v-if="measure">
                        {{ measure }}
                      </div>
                    </slot>
                  </template>
                </v-text-field>
                <vue-tel-input-vuetify
                  v-else-if="type === 'tel'"
                  v-bind:value="value"
                  @input="$emit('input', $event)"
                  outlined
                  :width="width"
                  :height="height"
                  label=""
                  :placeholder="placeholder || label"
                  mode="international"
                  disabledFetchingCountry
                  defaultCountry="FI"
                  :hide-details="hideDetails !== undefined ? hideDetails : 'auto'"
                  :rules="rulesCheck"
                  :readonly="readonly"
                />
                <v-textarea
                  :class="classInput"
                  ref="textarea"
                  v-else-if="type === 'textarea'"
                  v-bind:value="value"
                  @input="$emit('input', $event), handleInput"
                  outlined
                  :placeholder="placeholder || label"
                  :auto-grow="autoGrow"
                  no-resize
                  :width="width"
                  :rows="rows"
                  :hide-details="hideDetails !== undefined ? hideDetails : 'auto'"
                  :rules="rulesCheck"
                  @blur="handleBlur"
                  :counter="counter"
                  :readonly="readonly"
                  :disabled="disabled"
                  @change="handleChange"
                  @keydown="handleKeydown"
                  @focus="handleFocus"
                  @paste="handlePaste"
                >
                  <template v-slot:append-outer>
                    <slot name="append-outer" />
                  </template>
                </v-textarea>
                <v-autocomplete
                  :class="classInput + (minimize ? ' minimize' : ' ')"
                  ref="autocomplete"
                  v-else-if="type === 'autocomplete'"
                  :disabled="disabled"
                  :prepend-inner-icon="prependInnerIcon"
                  :append-outer-icon="appendOuterIcon"
                  :outlined="!minimize"
                  :filled="minimize"
                  dense
                  :width="width"
                  :height="chips || smallChips ? 'auto' : minimize ? '30' : height"
                  :min-height="minimize ? '30' : height"
                  :placeholder="placeholder"
                  v-bind:value="value"
                  @input="$emit('input', $event)"
                  :items="items"
                  :item-value="itemValue"
                  :item-text="itemText"
                  :append-icon="appendIcon ? appendIcon : 'fas fa-angle-down'"
                  menu-props="offset-y"
                  :hide-details="hideDetails !== undefined ? hideDetails : 'auto'"
                  :rules="rulesCheck"
                  class="selectCustom"
                  :multiple="multiple"
                  :chips="chips"
                  :small-chips="smallChips"
                  :deletable-chips="deletableChips"
                  @blur="edit = true"
                  :no-data-text="localStorage.translations.pages.common['text']['net-dannyh']"
                  @change="handleChange"
                  :clearable="clearable"
                >
                  <template v-slot:append-outer>
                    <slot name="append-outer" />
                  </template>
                  <template v-slot:selection="{ item, index }" v-if="filter">
                    <v-chip v-if="index === 0">
                      <span>{{ item.text }}</span>
                    </v-chip>
                    <span v-if="index === 1 && multiple" class="secondary--text text-caption">
                      (+{{ value.length - 1 }})
                    </span>
                  </template>
                </v-autocomplete>
                <v-select
                  :class="classInput + (minimize ? ' minimize' : ' ')"
                  ref="select"
                  v-else-if="type === 'select'"
                  :disabled="disabled"
                  :prepend-inner-icon="prependInnerIcon"
                  :append-outer-icon="appendOuterIcon"
                  class="selectCustom"
                  :outlined="!minimize"
                  :filled="minimize"
                  dense
                  :width="width"
                  :height="chips || smallChips ? 'auto' : minimize ? '30' : height"
                  :min-height="minimize ? '30' : height"
                  :placeholder="placeholder"
                  v-bind:value="value"
                  @input="$emit('input', $event)"
                  :items="items"
                  :item-value="itemValue"
                  :item-text="itemText"
                  :append-icon="appendIcon ? appendIcon : 'fas fa-angle-down'"
                  menu-props="offset-y"
                  :hide-details="hideDetails !== undefined ? hideDetails : 'auto'"
                  :rules="rulesCheck"
                  :multiple="multiple"
                  :chips="chips"
                  :small-chips="smallChips"
                  :deletable-chips="deletableChips"
                  @blur="edit = true"
                  :no-data-text="localStorage.translations.pages.common['text']['net-dannyh']"
                  @change="handleChange"
                >
                  <template v-slot:append-outer>
                    <slot name="append-outer" />
                  </template>
                  <template v-slot:prepend-inner>
                    <slot name="prepend-inner" />
                  </template>
                  <template v-slot:selection="{ item, index }" v-if="filter">
                    <v-chip v-if="index === 0">
                      <span>{{ item.text }}</span>
                    </v-chip>
                    <span v-if="index === 1 && multiple" class="secondary--text text-caption">
                      (+{{ value.length - 1 }})
                    </span>
                  </template>
                </v-select>
                <v-select
                  :class="classInput + (minimize ? ' minimize' : ' ')"
                  ref="select-language"
                  v-else-if="type === 'select-language'"
                  :disabled="disabled"
                  :prepend-inner-icon="prependInnerIcon"
                  :append-outer-icon="appendOuterIcon"
                  class="selectCustom"
                  :outlined="!minimize"
                  :filled="minimize"
                  dense
                  :width="width"
                  :height="chips || smallChips ? 'auto' : minimize ? '30' : height"
                  :min-height="minimize ? '30' : height"
                  :placeholder="placeholder"
                  v-bind:value="value"
                  @input="$emit('input', $event)"
                  :items="Object.values(languages)"
                  :item-value="(i) => i.id"
                  :item-text="(i) => i.name"
                  :append-icon="appendIcon ? appendIcon : 'fas fa-angle-down'"
                  menu-props="offset-y"
                  :hide-details="hideDetails !== undefined ? hideDetails : 'auto'"
                  :rules="rulesCheck"
                  @blur="edit = true"
                  :no-data-text="localStorage.translations.pages.common['text']['net-dannyh']"
                  @change="handleChange"
                >
                  <template v-slot:append-outer>
                    <slot name="append-outer" />
                  </template>
                  <template v-slot:prepend-inner>
                    <slot name="prepend-inner" />
                  </template>
                  <template v-slot:selection="{ item }">
                    <img class="language-icon" :src="item.image.svg" :alt="item.locale" />
                    <span class="ml-2">{{ item.name }}</span>
                  </template>
                </v-select>
                <v-dialog
                  v-else-if="type === 'datetime-picker'"
                  v-model="dialog"
                  width="max-content"
                  @click:outside="checkDateTimePicker"
                  @keydown="checkDateTimePicker"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      ref="date-picker"
                      :class="classInput"
                      v-on="on"
                      v-bind="attrs"
                      :prepend-inner-icon="prependInnerIcon ? prependInnerIcon : 'today'"
                      :append-outer-icon="appendOuterIcon"
                      v-model="dateFormatted"
                      outlined
                      readonly
                      :placeholder="placeholder || label"
                      hide-details="auto"
                      :width="width"
                      :height="height"
                      :rules="rulesCheck"
                      :disabled="disabled"
                    >
                      <template v-slot:append-outer>
                        <slot name="append-outer" />
                      </template>
                    </v-text-field>
                  </template>
                  <div class="wrap" :key="dialog + step">
                    <!-- {{dateMin && new Date(dateMin.split('T')[0]).toISOString()}}
                                        {{datetime.date && new Date(datetime.date).toISOString()}}
                                        {{dateMin && dateMin.split('T')[1]}} -->
                    <v-date-picker
                      v-if="step === 1"
                      :locale="$cookies.get('languageSelect').key"
                      v-model="datetime.date"
                      no-title
                      show-week
                      first-day-of-week="1"
                      :min="dateMin"
                      :max="dateMax"
                    ></v-date-picker>

                    <v-time-picker
                      v-else-if="step === 2"
                      v-model="datetime.time"
                      format="24hr"
                      :min="
                        dateMin && dateMin.split(' ')[0] == datetime.date
                          ? dateMin.split(' ')[1]
                          : undefined
                      "
                      :max="dateMax ? dateMax.split(' ')[1] : undefined"
                    ></v-time-picker>
                    <div class="wrap-btns">
                      <BaseButton
                        default_icon="button-back"
                        :text="
                          step === 1
                            ? localStorage.translations.pages.common.buttons.otmenit
                            : localStorage.translations.pages.common.buttons.nazad
                        "
                        @click="step === 1 ? (dialog = false) : (step = step - 1)"
                      />
                      <BaseButton
                        :disabled="step === 1 ? !datetime.date : !datetime.time"
                        :default_icon="step === 1 ? 'button-continue' : 'button-done'"
                        :text="
                          step === 1
                            ? localStorage.translations.pages.sales_project.buttons['prodolzhit']
                            : localStorage.translations.pages.common.buttons.primenit
                        "
                        @click="
                          step === 1
                            ? (step = 2)
                            : ((step = 1),
                              (dialog = false),
                              $emit('input', datetime.date + ' ' + datetime.time))
                        "
                      />
                    </div>
                  </div>
                </v-dialog>
                <v-dialog v-else-if="type === 'time-picker'" v-model="dialog" width="max-content">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      ref="time-picker"
                      :class="classInput"
                      v-on="on"
                      v-bind="attrs"
                      :prepend-inner-icon="prependInnerIcon ? prependInnerIcon : 'schedule'"
                      :append-outer-icon="appendOuterIcon"
                      v-model="value"
                      outlined
                      readonly
                      :placeholder="placeholder || label"
                      hide-details="auto"
                      :width="width"
                      :height="height"
                      :rules="rulesCheck"
                      :disabled="disabled"
                    >
                      <template v-slot:append-outer>
                        <slot name="append-outer" />
                      </template>
                    </v-text-field>
                  </template>
                  <div class="wrap" :key="dialog">
                    <v-time-picker
                      v-model="time"
                      format="24hr"
                      :min="timeMin"
                      :max="timeMax"
                    ></v-time-picker>
                    <div class="wrap-btns">
                      <BaseButton
                        :disabled="!time"
                        :default_icon="'button-done'"
                        :text="localStorage.translations.pages.common.buttons.primenit"
                        @click=";(dialog = false), $emit('input', time)"
                      />
                    </div>
                  </div>
                </v-dialog>
                <v-menu
                  v-else-if="type === 'date-picker'"
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                  :disabled="readonly"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      ref="date-picker"
                      :class="classInput"
                      v-on="on"
                      v-bind="attrs"
                      :prepend-inner-icon="prependInnerIcon ? prependInnerIcon : 'today'"
                      :append-outer-icon="appendOuterIcon"
                      v-model="dateFormatted"
                      outlined
                      readonly
                      @blur="value = parseDate(dateFormatted)"
                      :placeholder="placeholder || label"
                      hide-details="auto"
                      :width="width"
                      :height="height"
                      :rules="rulesCheck"
                      :disabled="disabled"
                      :clearable="clearable"
                      @click:clear="$emit('input', $event.target.value)"
                    >
                      <template v-slot:append-outer>
                        <slot name="append-outer" />
                      </template>
                    </v-text-field>
                  </template>
                  <v-date-picker
                    :locale="$cookies.get('languageSelect').key"
                    v-bind:value="value"
                    @input="
                      {
                        $emit('input', $event), (menu = false)
                      }
                    "
                    no-title
                    show-week
                    first-day-of-week="1"
                    :min="dateMin"
                    :max="dateMax"
                    :show-current="showCurrent"
                    @change="handleChange"
                  ></v-date-picker>
                </v-menu>
                <v-switch
                  v-else-if="type === 'switch'"
                  :class="classInput"
                  ref="switch"
                  color="#277faf"
                  inset
                  hide-details="auto"
                  :disabled="disabled"
                  :loading="loading"
                  :width="width"
                  :height="height"
                  :input-value="value"
                  @change="$emit('input', $event)"
                  @click="handleClick"
                ></v-switch>
                <v-card
                  class="hoverText"
                  v-if="hover && edit && value && type === 'autocomplete' && !chips && !smallChips"
                  @click="clickText"
                  :class="(prependInnerIcon ? 'leftIcon' : '') + (minimize ? ' minimize' : '')"
                >
                  {{
                    items.filter((i) => i[itemValue] === value)[0]
                      ? typeof itemText === 'function'
                        ? itemText(items.filter((i) => i[itemValue] === value)[0])
                        : items.filter((i) => i[itemValue] === value)[0][itemText]
                      : viewValue || value
                  }}
                </v-card>
                <div v-if="$slots.default" class="mt-1">
                  <slot />
                </div>
              </div>
              <template v-else>
                <slot name="viewValue">
                  <template v-if="!chips || !smallChips">
                    <div
                      class="f14 view-text"
                      v-if="type === 'textarea'"
                      v-html="
                        viewValue || value
                          ? String(viewValue || value).replace(/(?:\r\n|\r|\n)/g, '<br/>')
                          : '—'
                      "
                    />
                    <div class="f14 view-text" v-else :class="class_viewValue">
                      {{ viewValue || value }}
                    </div>
                  </template>
                </slot>
              </template>
            </v-hover>
          </transition>
        </div>
      </div>
    </BaseTooltip>
    <ButtonCopy
      v-if="copy && (view || disabled || readonly) && (viewValue || value)"
      :text="viewValue || value"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ButtonCopy from 'components/ButtonCopy'
import BaseLink from 'components/base/BaseLink'

export default {
  name: 'BaseInput',
  components: { BaseLink, ButtonCopy },
  refs: ['text', 'textarea', 'autocomplete', 'select', 'date-picker'],
  props: {
    autocomplete: {
      type: [String, Boolean, Date, Number],
      default: undefined,
    },
    autofocus: Boolean,
    label: String,
    labelSecond: String,
    labelSize: [String, Number],
    bold: {
      type: Boolean,
      default: true,
    },
    palaceholder: [String, Function],
    value: [String, Number, Function, Array, Object, Boolean],
    prependInnerIcon: String,
    appendOuterIcon: String,
    type: {
      type: String,
      default: 'text',
    },
    disabled: [Boolean, Function],
    rules: Array,
    maxWidth: [Number, String],
    view: Boolean,
    viewValue: [String, Number, Function, Object, Boolean],
    width: [String, Number],
    height: {
      type: [String, Number],
      default: 48,
    },
    rows: {
      type: [String, Number],
      default: 3,
    },
    hideDetails: {
      type: [Boolean, String],
      default: 'auto',
    },
    placeholder: String,
    items: Array,
    itemValue: {
      type: [String, Function],
      default: 'id',
    },
    itemText: {
      type: [String, Function],
      default: 'name',
    },
    appendIcon: {
      type: String,
      default: 'fas fa-angle-down',
    },
    tooltip: String,
    tooltipDisabled: Boolean,
    dateMin: [String, Date],
    dateMax: [String, Date],
    classInput: String,
    inputType: String,
    inputName: [String, Number],
    class_viewValue: {
      type: String,
      default: 'f14',
    },
    classLabel: {
      type: String,
      default: 'primary--text f14',
    },
    copy: Boolean,
    link: [Boolean, String],
    linkType: String,
    measure: [String, Function],
    multiple: {
      type: Boolean,
      default: false,
    },
    chips: Boolean,
    smallChips: Boolean,
    deletableChips: Boolean,
    autoGrow: {
      type: Boolean,
      default: false,
    },
    counter: [Boolean, String, Number],
    minimize: Boolean,
    readonly: Boolean,
    showCurrent: [String, Date],
    filter: Boolean,
    timeMin: [String],
    timeMax: [String],
    loading: [String, Boolean],
    clearable: Boolean,
    errorMessage: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      edit: true,
      menu: false,
      clickCopy: false,
      key: 0,
      step: 1,
      datetime: {},
      time: null,
      dialog: false,
    }
  },
  computed: {
    ...mapGetters(['inputRules']),
    ...mapGetters('languages', ['languages']),
    valid() {
      let result = this.$refs[this.type] && this.$refs[this.type].valid
      return result === undefined ? true : result
    },
    rulesCheck() {
      let result = []
      if (this.$el) {
        if (this.$el.closest('.width_check_table_breakpoint')) {
        } else {
          if (Array.isArray(this.rules) && this.rules.length) {
            for (let rule of this.rules) {
              // console.log('rule', rule)
              if (typeof rule === 'string') {
                result.push(this.inputRules[rule])
              } else {
                result.push(rule)
              }
            }
          }
        }
      } else {
        if (Array.isArray(this.rules) && this.rules.length) {
          for (let rule of this.rules) {
            // console.log('rule', rule)
            if (typeof rule === 'string') {
              result.push(this.inputRules[rule])
            } else {
              result.push(rule)
            }
          }
        }
      }
      return result
    },
    dateFormatted() {
      return this.type === 'date-picker' || this.type === 'datetime-picker'
        ? this.$formatDate(this.value)
        : null
    },
  },
  watch: {
    $props: {
      deep: true,
      handler() {
        this.key++
      },
    },
    valid() {
      const parentTr = this.$el.closest('tr')
      const parentTd = this.$el.closest('td')
      const targetClass = 'td--error'
      if (parentTd) {
        if (!this.valid) {
          // console.log('!this.valid', !this.valid)
          if (parentTd.classList && !parentTd.classList.contains(targetClass)) {
            parentTd.classList.add(targetClass)
          }
        } else {
          if (parentTd.classList && parentTd.classList.contains(targetClass)) {
            parentTd.classList.toggle(targetClass)
          }
        }
      }
      if (parentTr) {
        if (parentTr.querySelectorAll('.td--error').length) {
          if (parentTr.classList && !parentTr.classList.contains('listener--error')) {
            parentTr.classList.add('listener--error')
            parentTr.classList.add('active')
          }
        } else {
          if (parentTr.classList && parentTr.classList.contains('listener--error')) {
            parentTr.classList.remove('listener--error')
          }
        }
      }
    },
    value() {
      if (this.inputType === 'number') {
        // this.value = this.value.replace(',', '.').replace(/[^\d\.]/g, "").replace(/\./, "x").replace(/\./g, "").replace(/x/, ".")
        this.value = String(this.value).replace(/[^0-9\.]+/g, '')
      }
      this.checkDateTimePicker()
    },
  },
  mounted() {
    this.checkDateTimePicker()
  },
  methods: {
    handleChange(v) {
      this.$emit('change', v)
    },
    handleClick() {
      this.$emit('click')
    },
    handleKeydown(v) {
      this.$emit('keydown', v)
    },
    handleBlur(v) {
      this.$emit('blur', v)
    },
    handleFocus(v) {
      this.$emit('focus', v)
    },
    handlePaste(v) {
      this.$emit('paste', v)
    },
    handleInput(v) {
      this.$emit('input', v)
    },
    clearValue() {
      this.value = null
    },
    checkDateTimePicker() {
      if (this.type === 'datetime-picker') {
        if (this.value) {
          let array = this.value.split(' ')
          this.datetime = {
            date: array[0],
            time: array[1],
          }
        } else {
          this.datetime = {}
        }
        this.step = 1
      }
    },
    clickText() {
      this.edit = false
      if (this.type === 'autocomplete') {
        this.$refs.autocomplete.$refs.input.click()
      } else if (this.type === 'textarea') {
        this.$refs.textarea.$refs.input.click()
      } else if (this.type === 'text') {
        this.$refs.text.$refs.input.click()
      }
    },
    parseDate(date) {
      if (!date) return null
      const [day, month, year] = date.split('.')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
  },
}
</script>

<style lang="scss" scoped>
:deep() .v-input.v-text-field .v-input__slot:not(.v-textarea) {
  min-height: 30px !important;
}
:deep() .vue-tel-input-vuetify {
  .country-code {
    .v-input__slot {
      margin-bottom: 0 !important;
    }
    .v-text-field__details {
      display: none;
    }
  }
  .v-input.v-text-field .v-input__slot:not(.v-textarea) {
    min-height: 48px !important;
  }
}

.inp_container {
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: auto;
  align-items: end;
  height: max-content;
}

.base-input {
  &__header {
    label {
      display: block;
      margin-bottom: 5px;
      // color: #2c2c2c;
      color: #52525f;
      line-height: 16px !important;
    }

    .label_second {
      color: #52525f;
      margin-bottom: 8px;
      display: block;
      line-height: 16px !important;
    }
  }

  &__body {
    .hoverText {
      position: absolute;
      font-size: 1rem !important;
      line-height: 1em;
      font-weight: normal;
      color: #2c2c2c;
      top: 7px;
      left: 4px;
      width: max-content;
      min-width: max-content;
      z-index: 100;
      background-color: rgba(white, 0.95);
      border: none !important;
      box-shadow: none !important;
      padding: 8px;
      letter-spacing: 0 !important;
      font-stretch: normal !important;
      word-spacing: normal !important;

      &.minimize {
        top: 0 !important;
        height: 29px;
      }
    }

    :deep() .v-input {
      &--selection-controls {
        &__input {
          margin: 0;
          padding: 0;
        }
      }
      &--switch {
        margin-top: 0;
        padding-top: 0;

        .v-input__slot {
          height: max-content !important;
          min-height: auto !important;
          width: max-content;
        }
      }
    }
  }

  .bold {
    font-weight: 500;
  }

  .rel {
    position: relative !important;
  }

  .leftIcon {
    left: 32px !important;
  }
}

.wrap {
  background: #ffffff;
  display: grid;
  justify-content: center;

  &-btns {
    padding: 10px;
    display: flex;
    justify-content: space-between;
    gap: 10px;
  }
}
.language-icon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid rgb(221, 221, 221);
}
</style>
